import random from 'random-seed'

import standardMessages from '../../messages.json'

export default function generateSuccessMessage(
	stars: number,
	playerId: string,
	gameId: number | string,
	messages = null
): [string, string] {
	const _messages = messages || standardMessages
	let message1 = 'Success!'
	let message2 = 'Well done'

	const rng = random(playerId + gameId)
	const randFromArr = arr => arr[rng(arr.length)]

	// Get range of messages depending on stars achieved
	const msgs = _messages[stars.toString()]

	if (!msgs) return [message1, message2]

	if (msgs.special) {
		const rand = rng(100)
		if (rand === 0) {
			return randFromArr(msgs.special)
		}
	}

	message1 = randFromArr(msgs.part1)
	message2 = `${randFromArr(msgs.part2)} ${randFromArr(msgs.part3)}`

	return [message1, message2]
}
